






































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { TcwFormID } from '@/tcw/domain/types'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import _ from 'lodash'

@Component
export default class KoutsuhiPatternCard extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected pattern!: ApiGeneralSinglePayload
  @Prop({ type: Boolean, default: false })
  protected deletable!: boolean

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected deletePattern(patternId: TcwFormID): void {
    /**  */
  }

  protected get keiroStr(): string {
    if (!this.isSetKoutsuhiKeiro) {
      return ''
    }
    const keiroList = this.pattern.keiroList
    if (!_.isArray(keiroList)) {
      return ''
    }
    return this.tcw.createKoutsuhiKeiroStr(keiroList as ApiGeneralObjectArrayPayload)
  }

  protected get isSetKoutsuhiKeiro(): boolean {
    return Array.isArray(this.pattern.keiroList) && this.pattern.keiroList.length > 1
  }
  protected get isTeiki(): boolean {
    return this.pattern.teiki === '1'
  }
  protected get koutsuhi(): string {
    // FIXME 定期内の一部が交通費の場合どうするか
    const goukeiKingaku = Number(this.pattern.goukeiKingaku)
    if (Number.isNaN(goukeiKingaku)) {
      return ''
    }
    return `¥${goukeiKingaku.toLocaleString()}`
  }
  protected openEdit(patternId: TcwFormID): void {
    this.$router.push(`/pattern/koutsuhi/${patternId}`)
  }
}
